import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import Private from 'utils/Private';
import Layout from 'components/Layout';

import Front from './pages/Front';
import Contacts from './pages/Contacts';
import FAQ from './pages/FAQ';
import PaymentRules from './pages/PaymentRules';
import Specialists from './pages/Specialists';
import Specialist from './pages/Specialist';
import Shop from './pages/Shop';
import Item from './pages/ShopItem/Item';
import Digital from './pages/ShopItem/Digital';
import Cart from './pages/Cart';
import Profile from './pages/Profile';
import Office from './pages/Office';
import Orders from './pages/Orders';
import Purchases from './pages/Purchases';
import Certificates from './pages/Certificates';
import ForeignPayment from './pages/ForeignPayment';
import SupervisionsMaterials from './landings/Supervisions/Materials';
import SupervisionMaterials from './landings/Supervisions/Materials/Supervision';
import Audiobook from './landings/Audiobook';
import FeelingsCoursePodcasts from './landings/FeelingsCourse/Podcasts';
import FeelingsCourseVideo from './landings/FeelingsCourse/Video';
import MoneyCourseMaterials from './landings/MoneyCourse';
import NePapinaDochkaMaterials from './landings/NePapinaDochkaWebinar/Materials';
import ErrorPage from './pages/Error';
import FinishPayment from './pages/FinishPayment';
import LoginRedirect from './pages/LoginRedirect';
import CourseGenericMaterials from './pages/CourseGenericMaterials';
import { Conference } from './pages/Conference';
import SecretSanta from './landings/SecretSanta';

const ruDomain = ['otvet.co', 'www.otvet.co', 'localhost', '77.223.98.203', 'testing.otvet.co', '192.168.50.253', '95.84.228.38'];
export const isRuDomain = ruDomain.includes(window?.location?.hostname)
window.isRuDomain = isRuDomain;

const routes = [
    {
        path: '/',
        element: <Layout/>,
        errorElement: <Layout outlet = {<ErrorPage />} />,
        children: [
            {
                path: '/',
                element: <Front/>
            },
            {
                path: '/contacts',
                element: <Contacts/>
            },
            {
                path: '/faq',
                element: <FAQ/>
            },
            {
                path: '/payment_rules',
                element: <PaymentRules/>
            },
            {
                path: '/specialists',
                element: <Specialists/>
            },
            {
                path: '/specialists/:name',
                element: <Specialist/>
            },
            {
                path: '/goods/secret_santa',
                element: <SecretSanta/>
            },
            {
                path: '/goods',
                element: <Shop/>
            },
            {
                path: '/goods/tags/:tag',
                element: <Shop/>
            },
            {
                path: '/goods/:name',
                element: <Item/>
            },
            {
                path: '/courses/:name',
                element: <Digital />
            },
            {
                path: '/cart',
                element: <Cart />
            },
            {
                element: <Office />,
                children: [
                    {
                        element: <Private />,
                        children: [
                            {
                                path: '/profile',
                                element: <Profile/>
                            },
                            {
                                path: '/orders',
                                element: <Orders/>
                            },
                            {
                                path: '/items',
                                element: <Purchases/>
                            },
                            {
                                path: '/conference',
                                element: <Conference/>
                            }
                        ]
                    }
                ]
            },
            {
                path: '/materials/supervisions',
                element: <SupervisionsMaterials />,
            },
            {
                path: '/materials/supervisions/:supervision',
                element: <SupervisionMaterials />,
            },
            {
                path: '/book',
                element: <Audiobook />,
            },
            {
                path: '/materials/feelings-course-podcasts',
                element: <FeelingsCoursePodcasts />,
            },
            {
                path: '/materials/feelings-course-video',
                element: <FeelingsCourseVideo />,
            },
            {
                path: '/materials/money-course',
                element: <MoneyCourseMaterials />,
            },
            {
                path: '/check_payment/:payment_type/:token',
                element: <FinishPayment />
            },
            {
                path: '/user/digital/nepapina-dochka-materials',
                element: <NePapinaDochkaMaterials />,
            },
            {
                path: '/user/digital/:course',
                element: <CourseGenericMaterials />
            },
            {
                path: '/login',
                element: <LoginRedirect />
            },
            {
                element:  <Private />,
                children: [
                    {
                        path: '/orders/:orderId/conference',
                        element: <Conference/>
                    }
                ]
            }
        ],
    },
];

if (!isRuDomain) {
    routes[0].children.push({
        path: '/foreign-payments',
        element: <ForeignPayment />
    })
}

if (isRuDomain) {
    routes[0].children.push({
        path: '/certificates',
        element: <Certificates />
    })
}

const router = createBrowserRouter(routes);

export default router;
